var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',_vm._g(_vm._b({attrs:{"value":_vm.value,"fullscreen":_vm.isMobile,"scrollable":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-dialog',_vm.attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }